import styled, { css } from 'styled-components';
import DefaultLogotype from 'assets/brand/superorder.svg?react';
import { ComponentProps } from './types';

const Logotype = styled(DefaultLogotype)<ComponentProps>`
  ${({ $variant }) => {
    switch ($variant) {
      case 'white':
        return css`
          color: ${({ theme }) => theme.colors.white};
        `;
      case 'black':
        return css`
          color: ${({ theme }) => theme.colors.navyGreen};
        `;
      case 'green':
      default:
        return css`
          color: ${({ theme }) => theme.colors.greenLight};
        `;
    }
  }}
`;

export default Logotype;
